__turbopack_context__.v({
  "aspectBox": "RecipeDetail-module-scss-module__sJhHyW__aspectBox",
  "blocks": "RecipeDetail-module-scss-module__sJhHyW__blocks",
  "creator": "RecipeDetail-module-scss-module__sJhHyW__creator",
  "creatorLink": "RecipeDetail-module-scss-module__sJhHyW__creatorLink",
  "creatorsWrapper": "RecipeDetail-module-scss-module__sJhHyW__creatorsWrapper",
  "directionSection": "RecipeDetail-module-scss-module__sJhHyW__directionSection",
  "directions": "RecipeDetail-module-scss-module__sJhHyW__directions",
  "flushBottom": "RecipeDetail-module-scss-module__sJhHyW__flushBottom",
  "icon": "RecipeDetail-module-scss-module__sJhHyW__icon",
  "image": "RecipeDetail-module-scss-module__sJhHyW__image",
  "imageWrapper": "RecipeDetail-module-scss-module__sJhHyW__imageWrapper",
  "ingredients": "RecipeDetail-module-scss-module__sJhHyW__ingredients",
  "introContent": "RecipeDetail-module-scss-module__sJhHyW__introContent",
  "introSection": "RecipeDetail-module-scss-module__sJhHyW__introSection",
  "label": "RecipeDetail-module-scss-module__sJhHyW__label",
  "navButton": "RecipeDetail-module-scss-module__sJhHyW__navButton",
  "navLabel": "RecipeDetail-module-scss-module__sJhHyW__navLabel",
  "products": "RecipeDetail-module-scss-module__sJhHyW__products",
  "productsHeadline": "RecipeDetail-module-scss-module__sJhHyW__productsHeadline",
  "recipeLabel": "RecipeDetail-module-scss-module__sJhHyW__recipeLabel",
  "root": "RecipeDetail-module-scss-module__sJhHyW__root",
  "subImageCol": "RecipeDetail-module-scss-module__sJhHyW__subImageCol",
  "subImageColWrapper": "RecipeDetail-module-scss-module__sJhHyW__subImageColWrapper",
  "subImageIconWrapper": "RecipeDetail-module-scss-module__sJhHyW__subImageIconWrapper",
  "subImageInner": "RecipeDetail-module-scss-module__sJhHyW__subImageInner",
  "subImageWrapper": "RecipeDetail-module-scss-module__sJhHyW__subImageWrapper",
  "summary": "RecipeDetail-module-scss-module__sJhHyW__summary",
  "title": "RecipeDetail-module-scss-module__sJhHyW__title",
});
